import styled from 'styled-components';

export const Container = styled.section`
  border: 1px solid #4d4d4d;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 36px 24px;
  background-color: #ffffff;
`;

export const Title = styled.h4`
  font-size: 24px;
  color: ${({ color }) => color};
  margin: 0 0 24px 0;
  text-align: center;
`;

export const Text = styled.p`
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '16px')};
  color: #4d4d4d;
  text-align: center;
  margin: 4px 0;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 24px 0;
  button {
    width: 344px;
    height: 44px;
    background-color: ${({ color }) => color};
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-decoration: none;
    span {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: bold;
    }
  }
`;
